import { render } from "./pinned-message-removal-modal.vue?vue&type=template&id=d09e70d7"
import script from "./pinned-message-removal-modal.vue?vue&type=script&lang=js"
export * from "./pinned-message-removal-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__